/**
 * Verdict + plain-language explanation for each dosha check. Shared by the
 * Yoga & Dosha tab and the PDF report so both always say the same thing.
 * Each returns `{ present, verdict, detail }`.
 */

export function manglikVerdict(manglik) {
  return {
    present: manglik.present,
    verdict: manglik.present ? 'Present' : 'Not Present',
    detail:
      `Mars sits in house ${manglik.fromLagna ?? '—'} from your Lagna` +
      (manglik.fromMoon ? ` and house ${manglik.fromMoon} from your Moon.` : '.') +
      (manglik.present
        ? ' Classical texts advise matching with another Manglik chart or performing Mangal shanti before marriage.'
        : ' Houses 1, 2, 4, 7, 8 and 12 stay clear — no Mangal dosha applies.'),
  }
}

export function kalsarpaVerdict(kalsarpa) {
  return {
    present: !!kalsarpa?.present,
    verdict: kalsarpa ? (kalsarpa.present ? 'Present' : 'Not Present') : 'Unknown',
    detail: kalsarpa?.present
      ? 'All seven grahas fall on one side of the Rahu–Ketu axis. Rahu remedies and Nag puja are traditionally prescribed.'
      : kalsarpa
        ? `${kalsarpa.outsideCount} graha${kalsarpa.outsideCount === 1 ? '' : 's'} cross the Rahu–Ketu axis, so the serpent's grip is broken.`
        : 'The axis could not be computed.',
  }
}

export function sadesatiVerdict(sadesati) {
  return {
    present: !!sadesati?.active,
    verdict: sadesati ? (sadesati.active ? 'Active' : 'Not Active') : 'Unknown',
    detail: sadesati
      ? sadesati.active
        ? `Saturn currently transits ${sadesati.saturnSign} — house ${sadesati.houseFromMoon} from your natal Moon. ${sadesati.phase}. Discipline, patience and Shani remedies carry you through.`
        : `Saturn currently transits ${sadesati.saturnSign}, house ${sadesati.houseFromMoon} from your natal Moon — outside the Sadesati window (12th, 1st, 2nd).`
      : 'Saturn’s current transit could not be fetched.',
  }
}
